import { render, staticRenderFns } from "./SeriesHistoryShow.vue?vue&type=template&id=274a96a6&scoped=true&"
import script from "./SeriesHistoryShow.vue?vue&type=script&lang=js&"
export * from "./SeriesHistoryShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274a96a6",
  null
  
)

export default component.exports